import React, { PropsWithChildren } from 'react';
import { Box } from '@clariness/clarikit-react';
import {
  AccountPageLayoutForm,
  AccountPageLayoutHeading,
  AccountPageLayoutParagraph,
} from './components';

export const AccountPageLayout = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <Box display="flex" flexDirection="column" width="100%" maxWidth="654px">
      {children}
    </Box>
  );
};

AccountPageLayout.Heading = AccountPageLayoutHeading;
AccountPageLayout.Paragraph = AccountPageLayoutParagraph;
AccountPageLayout.Form = AccountPageLayoutForm;
